import { createContext, useContext } from 'react';

const FeaturesContext = createContext({});
export const useFeatures = () => useContext(FeaturesContext);

export default FeaturesContext;
